import * as React from 'react';
import { Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import { CardElement } from '@stripe/react-stripe-js';

interface Props {
    stripe: Stripe | null;
    elements: StripeElements | null;
    nameOnCard: string;
}

interface State {
}

class CheckoutForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {};
    }

    checkCreditCard = async (): Promise<{ stripeTokenId: string, createTokenError: string }> => {
        const { stripe, elements, nameOnCard } = this.props;

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make  sure to disable form submission until Stripe.js has loaded.
            return { stripeTokenId: '', createTokenError: '' };
        }

        const cardElement = elements.getElement(CardElement);
        const result = await stripe.createToken(cardElement as StripeCardElement, {name: nameOnCard});

        if (result.error) {
            // Show error to your customer.
            console.log('Create Token Error:', result.error.message);
            return { stripeTokenId: '', createTokenError: result.error.message ?? '' };
        } else {
            // Send the token to your server.
            // This function does not exist yet, we will define it in the next step.
            return { stripeTokenId: result.token?.id ?? '', createTokenError: '' };
        }
    }

    render(): JSX.Element {
        return (
            <>
                <CardElement
                    id="card-element"
                    options={{
                        style: {
                            base: {
                                fontSize: '13px',
                                color: '#888',
                                '::placeholder': {
                                    color: '#aab7c4',
                                }
                            },
                            invalid: {
                                color: '#EC4848',
                            },
                        },
                        disabled: false,
                        hidePostalCode: true
                    }}
                    // className="form-control-credit-card"
                />
            </>
        );
    }
}

export default CheckoutForm;


// WEBPACK FOOTER //
// ./src/components/Payment/CheckoutForm.tsx